import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { Group } from '@/types/user';
import { MultiEmailInput } from '@/features/settings/components/MultiEmailInput';


interface InviteUserDialogProps {
  open: boolean;
  groups: Group[];
  groupId: number;
  departments: { id: number; name: string }[];
  departmentId: number | null;
  loading: boolean;
  emails: string[];
  onClose: () => void;
  onInvite: () => void;
  onEmailsChange: (emails: string[]) => void;
  onGroupChange: (groupId: number) => void;
  onDepartmentChange: (departmentId: number | null) => void;
}

export const InviteUserDialog: React.FC<InviteUserDialogProps> = ({
  open,
  groups,
  groupId,
  departments,
  departmentId,
  loading,
  emails,
  onClose,
  onInvite,
  onEmailsChange,
  onGroupChange,
  onDepartmentChange,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      slotProps={{
        backdrop: {
          sx: { backdropFilter: 'blur(4px)' },
        },
      }}
    >
      <DialogTitle>Invite User</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} direction="column" sx={{ p: 2, width: 650 }}>
          <MultiEmailInput
            onChange={onEmailsChange}
            value={emails}
          />
          <FormControl fullWidth>
            <InputLabel id="select-label">Group</InputLabel>
            <Select
              id="group"
              label="Group"
              value={groupId}
              onChange={(e) => onGroupChange(e.target.value as number)}
              fullWidth
            >
              {groups.map((group) => (
                <MenuItem key={group.id} value={group.id}>
                  {group.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="select-label-department">Department</InputLabel>
            <Select
              id="department"
              label="Department"
              value={departmentId ?? ''}
              onChange={(e) => {
                const value = e.target.value as number | '';
                onDepartmentChange(value === '' ? null : value);
              }}
              fullWidth
            >
              <MenuItem value="">None</MenuItem>
              {departments.map((department) => (
                <MenuItem key={department.id} value={department.id}>
                  {department.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="default">
          Cancel
        </Button>
        <Button
          loading={loading}
          startIcon={<SendIcon />}
          variant="contained"
          onClick={onInvite}
        >
          Invite
        </Button>
      </DialogActions>
    </Dialog>
  );
};